import APICRUD from './apiCrud'
import URL from './urls'

export class Rates extends APICRUD {
  index(options) {
    return this.http().get(URL.RATES_URL, {
      params: {
        ...options,
        per_page: options.quantity,
        order_by: options.orderBy,
        order_flow: options.orderFlow
      }
    })
  }

  get(identifierRate) {
    return this.http().get(`${URL.RATES_URL}/${identifierRate}`, {})
  }

  save(data) {
    return this.http().post(URL.RATES_URL, data)
  }

  update(data) {
    console.log(this.http)
    return this.http().put(URL.RATES_URL + '/' + data.id, {
      ...data
    })
  }

  delete(id) {
    return this.http().delete(URL.RATES_URL + '/' + id)
  }
}

export default new Rates()
